export default "__VITE_ASSET__BSwhRDmf__"